import { useQuery } from "@tanstack/react-query";
import { queries } from "@core-shop/cache";

export function useFavorites({ isEnabled = false } = {}) {
  return useQuery({ ...queries.viewerFavorites(), enabled: isEnabled });
}
